import React from "react";
import "./apartmentLayout.css";
import Card from "./Card";
import PaymentPlans from "./PaymentPlans";
import CarouselSlider from "./CarouselSlider";
const ApartmentLayout = () => {
  return (
    <>
      {" "}
      <div className="layoutWrapper">
        <div className="overlay"></div>
        <h2>Our Apartment Layouts</h2>
        <Card />
      </div>
      <div className="layoutWrapper" style={{ marginTop: "-3.4%" }}>
        <div className="overlay"></div>
        <h2>Our Affordable Payment Plans!</h2>
        <PaymentPlans />
        <CarouselSlider />
      </div>
    </>
  );
};

export default ApartmentLayout;
